<section class="mx-auto max-w-screen-md">
    <h2 i18n class="mb-2 tracking-tight font-extrabold text-center">Send Me A Message</h2>
    <form #ngFormRef="ngForm" [formGroup]="form" (ngSubmit)="send()" class="space-y-8 my-8">
        <div class="sm:col-span-2">
            <!-- <label i18n for="email" class="block mb-1">Your email</label> -->
            <input class="w-full" type="email" formControlName="email" id="email" i18n-placeholder="Your email" placeholder="Your email" required />
            @if (form.errors && form.errors.email) {
                <span class="error"> {{ form.errors.email }} </span>
            }
        </div>

        <div class="sm:col-span-2">
            <!-- <label i18n for="message" class="block mb-1">Your message</label> -->
            <textarea class="w-full" formControlName="message" id="message" rows="6" i18n-placeholder="Your message..." placeholder="Your message..." required></textarea>
            @if (form.errors && form.errors.message) {
                <span class="error">{{ form.errors.message }}</span>
            }
        </div>

        <button [disabled]="processing() || form.invalid" type="submit" i18n>Send</button>
    </form>
</section>
